var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-dialog', {
    model: {
      value: _vm.isVisibleTemplateName,
      callback: function callback($$v) {
        _vm.isVisibleTemplateName = $$v;
      },
      expression: "isVisibleTemplateName"
    }
  }, [_c('dialog-template', [_c('div', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('saving.template.of.report'))
    },
    slot: "title"
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('labeled-input', {
    attrs: {
      "label": _vm.$t('template.name'),
      "placeholder": _vm.$t('new.template')
    },
    model: {
      value: _vm.templateName,
      callback: function callback($$v) {
        _vm.templateName = $$v;
      },
      expression: "templateName"
    }
  })], 1), _c('simple-button', {
    attrs: {
      "slot": "submit",
      "variant": "primary",
      "disabled": !_vm.isValidTemplateName
    },
    on: {
      "click": _vm.handleSavingTemplate
    },
    slot: "submit"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.save')) + " ")]), _c('simple-button', {
    attrs: {
      "slot": "cancel",
      "variant": "transparent"
    },
    on: {
      "click": function click($event) {
        _vm.isVisibleTemplateName = false;
      }
    },
    slot: "cancel"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }